import { HorizontalStepIndicator } from "@affinity/components/HorizontalStepIndicator";
import { Section } from "@affinity/components/Section";
import { Wrapper } from "@affinity/components/Wrapper/Wrapper";
import { breakpointWidth } from "@affinity/constants/StyleHelpers";
import { CustomState } from "@affinity/Store/Reducers";
import { useShellContext } from "@insite/client-framework/Components/IsInShell";
import Zone from "@insite/client-framework/Components/Zone";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import {
    ExcludeFromNavigation,
    ExcludeFromSignInRequired,
    HideFooter,
    HideHeader,
    MetaDescription,
    MetaKeywords,
    OpenGraphImage,
    OpenGraphTitle,
    OpenGraphUrl,
} from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page from "@insite/mobius/Page";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import styled from "styled-components";

// Fields Keys Enumerator
const enum fields {
    categoryFilterId = "categoryFilterId",
}

// CMS Properties Types for Component Usage
interface OwnProps extends PageProps {
    fields: {
        [fields.categoryFilterId]: string;
        // Reference additional fields required here with relevant typings
    };
}

// Map Application State (Redux) to Component Properties
const mapStateToProps = (state: CustomState) => {
    return {
        // Map state required to component properties with relevant typings
    };
};

// Bind Handlers to Component
const mapDispatchToProps = {
    // Reference handlers required
};

// Combine Properties
type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

// Page Implementation
const AffinityContentPage: React.FC<Props> = ({
    id,
}) => {
    return (
        <Page hasCustomBackground>
            <PageGridContainer>
                <HeaderContainer>
                    <Zone contentId={id} zoneName="AffinityHeader" requireRows={false} />
                </HeaderContainer>
                <Section>
                <Zone contentId={id} zoneName="AffinityContent" requireRows={false} />
                </Section>
                <Zone contentId={id} zoneName="AffinitySidebar" requireRows={false} />
            </PageGridContainer>
        </Page>
    );
};

export const PageGridContainer = styled(Wrapper)`
    @media (min-width: ${breakpointWidth("lg")}) {
        display: grid;
        grid-template-columns: minmax(1px, 8fr) minmax(1px, 4fr);
        max-width: none;
    }
`;

export const HeaderContainer = styled.div`
    grid-column: 1 / -1;
`;

// CMS Property Definitions
const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(AffinityContentPage),
    definition: {
        hasEditableTitle: true,
        hasEditableUrlSegment: true,
        pageType: "Content",
        fieldDefinitions: [
            MetaKeywords,
            MetaDescription,
            OpenGraphTitle,
            OpenGraphUrl,
            OpenGraphImage,
            HideHeader,
            HideFooter,
            ExcludeFromNavigation,
            ExcludeFromSignInRequired,
            {
                name: fields.categoryFilterId,
                displayName: "Category Filter GUID",
                defaultValue: "",
                editorTemplate: "TextField",
                fieldType: "General",
                isRequired: true,
                sortOrder: 150,
            },
        ],
    },
};

export default pageModule;
export const FunctionalComponentsContext = "AffinityContentPage";
